import { FunctionComponent } from 'react';

import styles from './RestrictedLayout.module.scss';

export const RestrictedLayout: FunctionComponent<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div
      id="restricted-layout"
      data-testid="restricted-layout"
      className={styles.restrictedLayout}
    >
      <header>
        <img
          src="https://www.haven.com/assets/logos/haven_logo_colour.svg"
          alt="Haven logo"
        />
      </header>
      <div className={styles.container}>{children}</div>
    </div>
  );
};
